import React from "react";
import "./item_table.scss";

const titles = ["Sales Item", "Sales Item Description", "Quantity", "Internal Service", "Price", "Currency"];

const CostPackageItemTable = ({ items, cpID, className, ...props }) => {
    const rows =
        items &&
        Object.values(items).map((item, index) => {
            return (
                <tr key={`item_value_${index}`} style={{ textAlign: "center" }}>
                    <td>{item.sales_item_code}</td>
                    <td>{item.description}</td>
                    <td>{item.quantity}</td>
                    <td>{item.internal_service ? "Yes" : "No"}</td>
                    <td>{item.price}</td>
                    <td>{item.currency.name}</td>
                </tr>
            );
        });
    const header = (
        <nav className="navbar">
            <span className="navbar-brand h4">CPO Items Level.</span>
        </nav>
    );
    props.setheader(header);

    return (
        <div {...{ className }}>
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`item_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
            {/* <Pagination {...pagination} /> */}
        </div>
    );
};

export default CostPackageItemTable;
